const types = {
  SET_ACTIVE_STEP: "SET_ACTIVE_STEP",
};

export default types;
